import React, { FC } from 'react';
import styled from 'styled-components/native';
import { SelectorPill } from '../SelectorPill/SelectorPill';
import { SelectorPillsProps } from './SelectorPills.props';

export const SelectorPills: FC<SelectorPillsProps> = (props) => {
  const { items, value, onChange, ...rest } = props;

  return (
    <Container {...rest}>
      {items.map((item) => (
        <SelectorPill
          key={item.id}
          color={item.color}
          backgroundColor={item.backgroundColor}
          selected={value === item.label}
          label={item.label}
          disabled={props.disabled}
          onPress={() => onChange(item.label)}
        />
      ))}
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;
